export enum BookingType {
    Past = 0,
    Active = 1,
    Upcoming = 2,
    Pending = 4,
    All = 3,
}

export enum PaymentStatus {
    All = 0,
    Pending = 1,
    Completed = 2,
    Processing = 4,
    Failure = 5,
    Cancelled = 9,
    Scheduled = 11,
    Disputed = 12,
}
export enum BookingStatus {
    Cancelled = 'Cancelled',
    Completed = 'Completed'
}
export enum BookingTypeFilterList {
    Onetime = 0,
    Recurring = 1,
    All = null,
}
export interface BookingListRequest {
    startDate: Date;
    endDate: Date;
    parkingLotName: string;
    search: string;
    status: BookingType;
    pageSize: number;
    pageNumber: number;
    timeZone: string;
    IsOwnerOrManagerCreated: boolean;
    paymentStatus?: number;
}
export interface DriverBookingListRequest {
    startDate: string;
    endDate: string;
    parkingLotName: string;
    status: BookingType;
    pageSize: number;
    pageNumber: number;
    paymentStatus: number;
    search: string;
    bookingType: number;
    isHazardousLoad: boolean;
}

export interface DriverBookingResponse {
    map(arg0: (item: any) => any): string;
    slotName: string;
    address: string;
    arrivalTimeStamp: number;
    amount: string;
    pageSize: number;
    pageNumber: number;
    totalCount: number;
}

export interface BookingListResponse {
    pastCount: number;
    currentCount: number;
    upcomingCount: number;
    totalRecords: number;
    bookingList: Booking[];
}

export interface Booking {
    parkingLotAddress?: any;
    groupName?: any;
    email?: any;
    creator?: any;
    children: any;
    parkingLotName?: string;
    arrivalDate?: string | number | Date;
    departureDate?: string | number | Date;
    billingCycle?: any;
    spotCount?: any;
    equipmentType?: any;
    createdDate?: string | number | Date;
    amount?: any;
    id: string;
    isHazardousLoad: boolean;
    mcNumber: string;
    driverName: string;
    location: string;
    bookingDate: string;
    slotName: string;
    total: number;
    createdBy: string;
    startDate: Date;
    endDate: Date;
    status: string;
    truckType: string;
    discount: number;
    taxAndFees: number;
    hazardousCharge: number;
    bookingType?: number;
    couponDiscount?: number;
    usedCredit?: number;
    paymentStatus?: number;
    driverEmailId?: string;
    recurringCount?: number;
    invoiceNumber?: string;
    transactionFees?: string;
    parentId?: string;
    bookingCreatedDate?: string;
    paymentInfo: PaymentInfo;
    dotNumber?: string;
    licenseNumberPlate?: string;
    vinNumber?: string;
    make?: string;
    year?: number;
    color?: string;
    createdByType?: string;
    createdByName?: string;
    bookingPaymentMode?: number;
}

export interface PaymentInfo {
    bookingStatus: {
        code?: number;
        description?: string;
        label?: string;
    };
}
export interface DriverList {
    driverName: string;
    profileImagePath: string;
    email: string;
    mobileNumber: string;
    countryCode: string;
    iso: string;
    dateCreated: string;
    status: boolean;
}
export interface BookingSummary {
    id: string;
    driverDetail: string;
    parkingArea: string;
    vehicleType: string;
    vehicleInformation: string;
    duration: string;
    discount: number;
    enterTimeIst: string;
    exitTimeIst: string;
    total: number;
    parkingLayout: string;
    parkingSlot: string;
    paidAmount: number;
    isParkingLotLayoutDoc: boolean | null;
    arrivalTime: string;
    departureTime: string;
    usedCredit: number;
    status: string;
    paymentStatus: number;
    address: string;
    arrivalTimeStamp: string;
    departureTimeStamp?: string;
    bookingQRCode: string;
    accessCode: string;
    driverName: string;
    driverMobile: number;
    paymentFailureError: string;
    bookingStatus?: any;
    isOpenGateIntegarted?: boolean;
    companyLogo?: string;
    truckCheckOutUrl?: string;
}

export interface ConfirmPayment {
    bookingId: string;
    cardToken: string;
    bookingPaymentMode?: number;
}

export enum BookingTypeDetails {
    Onetime = 0,
    Recurring = 2,
}

export enum CancelType {
    IsBookingRefund = 1,
    IsBookingWithoutRefund = 2,
    IsBookingOnlySubscriptionCancel = 3
}
